module.exports = __webpack_public_path__ + "img/geotrust.032ec94e.svg";